import { NgModule } from '@angular/core'
import { RouterModule, Routes, PreloadAllModules } from '@angular/router'
import { userInfoLoadedGuard } from './guards/user-info-loaded.guard'
import LEGACY_REDIRECTS from './legacy-redirects.routes'
import { BenefitsModule } from './pages/benefits/benefits.module'
import { LoginErrorComponent } from './pages/login-error/login-error.component'
import { LogoutComponent } from './pages/logout/logout.component'
import { SuppliersComponent } from './pages/suppliers/suppliers.component'
import { HomeComponent } from './pages/home/home.component'
import { ProfileComponent } from './pages/profile/profile.component'
import { OtherServicesComponent } from './pages/other-services/other-services.component'
import { VisualizersComponent } from './pages/visualizers/visualizers.component'
import { CommissionsComponent } from './pages/commissions/commissions.component'
import { CreateClaimComponent } from './pages/create-claim/create-claim.component'
import { EmployeeFormPageComponent } from './pages/profile/employees/employee-form-page/employee-form-page.component'
import { ClaimDetailComponent } from './pages/claim-detail/claim-detail.component'
import { MysalesComponent } from './pages/mysales/mysales.component'
import { RegisterSalesFormComponent } from './pages/register-sales-form/register-sales-form.component'
import { SamplesDetailComponent } from './pages/mysamples/samples-detail/samples-detail.component'
import { MyRewardsComponent } from './pages/myrewards/myrewards.component'
import { MyPointsComponent } from './pages/mypoints/mypoints.component'
import { TransactionsSummaryComponent } from './pages/mypoints/transactions-summary/transactions-summary.component'
import { EmployeeSummaryComponent } from './pages/mypoints/employee-summary/employee-summary.component'
import { RedeemedRewardsSummaryComponent } from './pages/mypoints/redeemed-rewards/redeemed-rewards.component'
import { LoadingComponent } from '@components/loading/loading.component'
import { MydisplaysComponent } from './pages/mydisplays/mydisplays.component'
import { RegisterDisplayFormComponent } from './pages/register-display-form/register-display-form.component'
import { SignContractComponent } from './pages/sign-contract/sign-contract.component'
import { MysamplesModule } from './pages/mysamples/mysamples.module'
import { LoginModule } from './pages/login/login.module'
import { MygalleriesModule } from './pages/mygalleries/mygalleries.module'
import { NewgalleriesModule } from './pages/newgalleries/newgalleries.module'
import { NewClaimModule } from './pages/new-claim/new-claim.module'
import { FabricatorRewardsModule } from './pages/fabricator-rewards/fabricator-rewards.module'
import { MyClaimsModule } from './pages/myclaims/myclaims.module'
import { PartnersModule } from './pages/partners/partners.module'
import { SalesSupportModule } from './pages/sales-support/sales-support.module'
import { C_ACADEMY_ROUTES } from './pages/c-academy/routes'
import { contractSignedGuard } from './guards/contract-signed.guard'
import { claimsAccessGuard } from './guards/claims-access.guard'
import { ContractType } from './interfaces/contract-type'
import { OnlineVisitComponent } from './pages/online-visit/online-visit.component'
import {
    NaturalStoneColorListComponent
} from './pages/natural-stone/natural-stone-color-list/natural-stone-color-list.component'
import {
    NaturalStoneLotListComponent
} from './pages/natural-stone/natural-stone-lot-list/natural-stone-lot-list.component'
import {
    NaturalStoneFinalizePreorderComponent
} from './pages/natural-stone/natural-stone-finalize-preorder/natural-stone-finalize-preorder.component'
import {
    NaturalStoneLotDetailComponent
} from './pages/natural-stone/natural-stone-lot-detail/natural-stone-lot-detail.component'

const routes: Routes = [
    ...LEGACY_REDIRECTS,
    { path: 'login', loadChildren: () => LoginModule },
    { path: 'login-error', component: LoginErrorComponent },
    { path: 'logout', component: LogoutComponent },
    {
        path: '',
        canActivateChild: [userInfoLoadedGuard],
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },
            {
                path: 'home', component: HomeComponent,
            },
            {
                path: 'profile',
                // canActivate: guards,
                component: ProfileComponent,
            },
            {
                path: 'benefits',
                // canActivate: guards,
                loadChildren: () => BenefitsModule,
            },
            {
                path: 'other-services',
                // canActivate: guards,
                component: OtherServicesComponent,
            },
            {
                path: 'online-visit',
                component: OnlineVisitComponent,
            },
            {
                path: 'visualizers',
                // canActivate: guards,
                component: VisualizersComponent,
            },
            {
                path: 'my-bonuses',
                // canActivate: guards,
                component: CommissionsComponent,
            },
            {
                path: 'c-academy',
                // canActivate: guards,
                children: C_ACADEMY_ROUTES
            },
            {
                path: 'create-claim',
                canActivate: [claimsAccessGuard],
                component: CreateClaimComponent,
            },
            {
                path: 'create-claim/:claimId',
                canActivate: [claimsAccessGuard],
                component: CreateClaimComponent,
            },
            { path: 'employee', component: EmployeeFormPageComponent },
            { path: 'my-galleries', loadChildren: () => MygalleriesModule },

            { path: 'my-gallery', loadChildren: () => NewgalleriesModule },
            { path: 'new-claim', loadChildren: () => NewClaimModule, canActivate: [claimsAccessGuard] },
            {
                path: 'fabricator-rewards',
                loadChildren: () => FabricatorRewardsModule,
                canActivate: [contractSignedGuard],
                data: { contract: <ContractType> 'fabricator-rewards' }
            },
            { path: 'my-claims', loadChildren: () => MyClaimsModule, canActivate: [claimsAccessGuard] },
            { path: 'partners', loadChildren: () => PartnersModule },
            { path: 'sales-support', loadChildren: () => SalesSupportModule },
            { path: 'claim-detail/:id', component: ClaimDetailComponent, canActivate: [claimsAccessGuard] },
            { path: 'my-sales', component: MysalesComponent },
            { path: 'new-sales', component: RegisterSalesFormComponent },
            {
                path: 'new-sales/:id',
                component: RegisterSalesFormComponent,
            },
            {
                path: 'new-sales/:id/:warrantyStep',
                component: RegisterSalesFormComponent,
            }, // // { path: 'sales-detail/:id', component: SalesDetailComponent },
            { path: 'my-samples', loadChildren: () => MysamplesModule },
            {
                path: 'my-samples/sample-detail/:id',
                component: SamplesDetailComponent,
            },
            { path: 'retail-rewards', component: MyRewardsComponent },
            { path: 'my-points', component: MyPointsComponent },
            {
                path: 'my-points/transaction-summary',
                component: TransactionsSummaryComponent,
            },
            {
                path: 'my-points/employee-summary',
                component: EmployeeSummaryComponent,
            },
            {
                path: 'my-points/redeemed-rewards',
                component: RedeemedRewardsSummaryComponent,
            },
            {
                path: 'loading',
                component: LoadingComponent,
            },
            {
                path: 'my-displays',
                component: MydisplaysComponent,
                canActivate: [contractSignedGuard],
                data: { contract: <ContractType> 'my-displays' }
            },
            {
                path: 'register-display',
                component: RegisterDisplayFormComponent,
                canActivate: [contractSignedGuard],
                data: { contract: <ContractType> 'my-displays' }
            },
            {
                path: 'suppliers',
                component: SuppliersComponent,
            },
            {
                path: 'natural-stone',
                component: NaturalStoneColorListComponent
            },
            {
                path: 'natural-stone/lots/:centerId/:sku',
                component: NaturalStoneLotListComponent
            },
            {
                path: 'natural-stone/lots/:centerId/:sku/:lotId',
                component: NaturalStoneLotDetailComponent
            },
            {
                path: 'natural-stone/finalize',
                component: NaturalStoneFinalizePreorderComponent
            },
            {
                path: 'sign-contract/:contractId',
                component: SignContractComponent,
            },
            {
                path: '**',
                redirectTo: 'home',
            }
        ],
    },
]


@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

